var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmationDialog',{attrs:{"isOpen":_vm.isOpen,"title":_vm.$t('stock.leave.title'),"message":_vm.message,"confirmText":_vm.$t('stock.leave.discard'),"cancelText":_vm.$t('stock.leave.continue'),"type":"warning"},on:{"confirm":function($event){return _vm.$emit('discard')},"cancel":function($event){return _vm.$emit('continue')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }